import { render, staticRenderFns } from "./TransportServicesInPayment.vue?vue&type=template&id=137d331c&"
import script from "./TransportServicesInPayment.vue?vue&type=script&lang=js&"
export * from "./TransportServicesInPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports